import { ncbClient } from './ncbClient';

export const paymentService = {
  async createPaymentIntent(amount, currency = 'usd') {
    try {
      // For NoCodeBackend, we'll create a payment record directly
      const response = await ncbClient.createPayment({
        amount: amount,
        payment_method: 'credit_card',
        payment_date: new Date().toISOString()
      });
      
      return {
        id: `pi_${response.id}`,
        client_secret: `pi_${response.id}_secret_${Math.random().toString(36).substr(2,9)}`
      };
    } catch (error) {
      throw new Error('Failed to create payment intent');
    }
  },

  async confirmPayment(paymentIntentId, paymentMethodId) {
    try {
      // Extract payment ID from paymentIntentId
      const paymentId = paymentIntentId.replace('pi_', '');
      const response = await ncbClient.updatePayment(paymentId, {
        transaction_id: paymentMethodId,
        payment_method: 'credit_card'
      });
      return response;
    } catch (error) {
      throw new Error('Payment confirmation failed');
    }
  },

  async processRefund(paymentIntentId, amount) {
    try {
      const paymentId = paymentIntentId.replace('pi_', '');
      const response = await ncbClient.createPayment({
        amount: -amount, // Negative amount for refund
        payment_method: 'refund',
        payment_date: new Date().toISOString()
      });
      return response;
    } catch (error) {
      throw new Error('Refund processing failed');
    }
  },
};